// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__0oZky","hidden":"Feedback_hidden__8sk1E","shown":"Feedback_shown__44yLO","message":"Feedback_message__0Wutl"};